export namespace Application {
  export type Id = '-1' | '101' | '138' | '10047' | '10048';

  export type Details = {
    id: Id;
  };
}

export type Application = typeof Application;

export const Application = {
  General: {
    id: '-1',
  },
  Nucleus: {
    id: '10048',
  },
  System: {
    id: '101',
  },

  Tables: {
    id: '138',
  },

  IQ_Hub: {
    id: '10047',
  },
} as const satisfies Record<string, Application.Details>;
